import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { getOrderCategoryName } from '../../../models/toBeCompletedTreatment'

export const Columns = (
  onClick: (text: string, t: any, flag?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '数据录入时间',
      dataIndex: 'createTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.createTime
          ? moment(t.createTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '首营日期',
      dataIndex: 'firstTime',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.firstTime
          ? moment(t.firstTime).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '首营企业名称',
      dataIndex: 'name',
      align: 'center',
      width: '14rem',
      ellipsis: true,
      render: (_, t) => {
        return t.name ? t.name : '-'
      },
    },
    {
      title: '许可证类型',
      dataIndex: 'licenceCategory',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.licenceCategory ? t.licenceCategory : '-'
      },
    },
    {
      title: '许可证编号',
      dataIndex: 'licenceNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.licenceNumber ? t.licenceNumber : '-'
      },
    },
    {
      title: '许可证有效期',
      dataIndex: 'licenceDeadline',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.licenceDeadline
          ? moment(t.licenceDeadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '营业执照编号',
      dataIndex: 'supplierTaxNo',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierTaxNo ? t.supplierTaxNo : '-'
      },
    },
    {
      title: '营业执照有效期',
      dataIndex: 'taxDeadline',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.taxDeadline
          ? moment(t.taxDeadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '生产(经营)范围',
      dataIndex: 'supplierRange',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierRange ? t.supplierRange : '-'
      },
    },
    {
      title: '开户户名',
      dataIndex: 'accountName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.accountName ? t.accountName : '-'
      },
    },
    {
      title: '开户银行',
      dataIndex: 'bankName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.bankName ? t.bankName : '-'
      },
    },
    {
      title: '银行账号',
      dataIndex: 'accountNo',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.accountNo ? t.accountNo : '-'
      },
    },
    {
      title: 'GSP/GMP证书编号',
      dataIndex: 'gspGmpNumber',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.gspGmpNumber ? t.gspGmpNumber : '-'
      },
    },
    {
      title: 'GSP/GMP证书有效期',
      dataIndex: 'gspGmpDeadline',
      align: 'center',
      width: '11rem',
      ellipsis: true,
      render: (_, t) => {
        return t.gspGmpDeadline
          ? moment(t.gspGmpDeadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '业务员姓名',
      dataIndex: 'concatName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => (t.concatName ? t.concatName : '-'),
    },
    {
      title: '业务员手机号',
      dataIndex: 'concatPhone',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => (t.concatPhone ? t.concatPhone : '-'),
    },
    {
      title: '采购员意见',
      dataIndex: 'buyOpinionFlag',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.buyOpinionFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '1')
                }}
              >
                去审核
              </Button>
            ) : t?.buyOpinionFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.buyOpinionFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },
    {
      title: '质量负责人意见',
      dataIndex: 'latelyOperatorName',
      align: 'center',
      width: '9rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.qualityAuditFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '2')
                }}
              >
                去审核
              </Button>
            ) : t?.qualityAuditFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.qualityAuditFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },
    {
      title: '企业负责人意见',
      dataIndex: 'latelyOperatorName',
      align: 'center',
      width: '9rem',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <>
            {t?.approvalOpinionFlag == 0 ? (
              <Button
                type='link'
                size='small'
                disabled={t?.isEdit?.toString() == '0' ? true : false}
                onClick={() => {
                  onClick('goForReview', t, '3')
                }}
              >
                去审核
              </Button>
            ) : t?.approvalOpinionFlag == 1 ? (
              <CheckCircleOutlined
                style={{ width: 22, height: 22, color: '#35d733' }}
              />
            ) : t?.approvalOpinionFlag == -1 ? (
              <CloseCircleOutlined
                style={{ width: 22, height: 22, color: 'red' }}
              />
            ) : (
              ''
            )}
          </>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '15rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('lookDetail', t)
              }}
            >
              详情
            </Button>
            <Button
              danger
              ghost
              disabled={t?.isEdit == 1 ? false : true}
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onClick('print', t)
              }}
            >
              打印
            </Button>
          </>
        )
      },
    },
  ]
}
